import "./styles/Header.css";
import Carousel2 from "./Carousel2";

export default function Wave() {
  return (
    <section className="modern-wave" aria-labelledby="modern-wave-title">

      {/* Ambient background */}
      <div className="modern-wave-noise" aria-hidden="true" />
      <div className="modern-wave-glow modern-wave-glow-left" aria-hidden="true" />
      <div className="modern-wave-glow modern-wave-glow-right" aria-hidden="true" />

      <div className="modern-wave-inner">

        {/* Header */}
        <header className="modern-wave-header">

          <div className="modern-wave-label">
            <span className="modern-wave-label-dot" />
            EXPLORE TUBBEES
          </div>

          <h2 id="modern-wave-title">
            Find your next
            <span>favourite stop.</span>
          </h2>

          <p>
            From your first sip to your last one,
            discover the Tubbees locations waiting
            to become your new favourite.
          </p>

        </header>


        {/* Carousel */}
        <div className="modern-wave-carousel">
          <Carousel2 />
        </div>


        {/* Bottom information */}
        <div className="modern-wave-footer">

          <div className="modern-wave-footer-line" />

          <span>
            DISCOVER • VISIT • ENJOY
          </span>

          <div className="modern-wave-footer-line" />

        </div>

      </div>

    </section>
  );
}